/**
 * company模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const company = {
  // 查询所有公司
  selectCompany(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/company/selectCompany`, param);
  },
  // 查询公司下拉框
  getCompanyDropDownBox(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/company/getCompanyDropDownBox`, param);
  },
  // 添加公司
  createCompany(params) {
    return $http.post(`${global.API_URL}/sme/company/create`, params);
  },
  // 编辑公司
  updateCompany(params) {
    return $http.post(`${global.API_URL}/sme/company/update`, params);
  },
  // 分页查询公司
  pageCompany(params) {
    return $http.post(`${global.API_URL}/sme/company/page`, params);
  },
  // 公司删除
  deleteCompany(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/company/delete`, param);
  },
  // 查询当前用户公司名称
  getCompanyName(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/company/getCompanyName`, param);
  },
  // 禁用激活
  activeDisable(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/company/activeDisable`, param);
  },
  // 查询客户类型下拉框
  getCustomerTypeDropDownBox(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/company/getCustomerTypeDropDownBox`, param);
  },
  //导出
  export(params) {
    return $http.post(`${global.API_URL}/sme/company/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 生成激活码
    generateVipActiveCode(params){
      return $http.post(`${global.API_URL}/sme/vip/generateVipActiveCode`,params);
    },
  // 点击开启关闭激活
  vipActiveDisable(id,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/company/vipActiveDisable`,param);
  }
}

export default company



// WEBPACK FOOTER //
// ./src/api/company.js